import { render, staticRenderFns } from "./FolderSettingsCorporateIdentity.vue?vue&type=template&id=6292ad4c&scoped=true"
import script from "./FolderSettingsCorporateIdentity.vue?vue&type=script&lang=js"
export * from "./FolderSettingsCorporateIdentity.vue?vue&type=script&lang=js"
import style0 from "./FolderSettingsCorporateIdentity.vue?vue&type=style&index=0&id=6292ad4c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6292ad4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6292ad4c')) {
      api.createRecord('6292ad4c', component.options)
    } else {
      api.reload('6292ad4c', component.options)
    }
    module.hot.accept("./FolderSettingsCorporateIdentity.vue?vue&type=template&id=6292ad4c&scoped=true", function () {
      api.rerender('6292ad4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/folders/FolderSettingsCorporateIdentity.vue"
export default component.exports